import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const waterSourceDocumentStatus = enumerated({
  pending: 'Pendente',
  success: 'Sucesso',
  failed: 'Falhou',
})

export const waterSourceDocumentObject = z.object({
  id: z.string().uuid(),
  waterSourceApplicationId: z.string().uuid(),
  privateFileId: z.string().uuid().nullish(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  status: waterSourceDocumentStatus,
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const waterSourceDocumentCreateInputObject = waterSourceDocumentObject
  .pick({
    id: true,
    waterSourceApplicationId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .extend({
    id: waterSourceDocumentObject.shape.id.nullish(),
    status: waterSourceDocumentObject.shape.status.nullish(),
  })

export const waterSourceDocumentUpdateInputObject = waterSourceDocumentObject
  .pick({
    id: true,
    waterSourceApplicationId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .partial()
  .required({ id: true })

export type WaterSourceDocumentType = z.infer<typeof waterSourceDocumentObject>

export const propertyMap = {
  id: sql`water_source_application_document.id`,
  waterSourceApplicationId: sql`water_source_application_document.water_source_application_id`,
  privateFileId: sql`water_source_application_document.private_file_id`,
  gcsIdentifier: sql`water_source_application_document.gcs_identifier`,
  url: sql`water_source_application_document.url`,
  fileName: sql`water_source_application_document.file_name`,
  mimeType: sql`water_source_application_document.mime_type`,
  status: sql`water_source_application_document.status`,
  clientId: sql`water_source_application_document.client_id`,
  insertUserId: sql`water_source_application_document.insert_user_id`,
  editUserId: sql`water_source_application_document.edit_user_id`,
  createdAt: sql`water_source_application_document.created_at`,
  updatedAt: sql`water_source_application_document.updated_at`,
  deletedAt: sql`water_source_application_document.deleted_at`,
}

export default waterSourceDocumentObject
